function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 85.333h512V426.67H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.33h512v341.332"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M300.611 300.621c-7.011 2.754-15.156 2.462-22.223-1.505-12.486-7.008-16.944-22.871-9.934-35.359l-2.128-1.193c21.38-5.156 37.199-24.562 36.922-47.464-.173-14.238-6.535-26.976-16.486-35.692l-15.582 15.963c5.891 4.695 9.71 11.896 9.808 19.998.174 14.319-11.335 26.111-25.653 26.285l.029 2.439c-15.155-15.937-39.87-19.932-59.565-8.242-12.243 7.269-20.093 19.147-22.667 32.124l21.616 5.513c1.121-7.45 5.447-14.357 12.414-18.494 12.314-7.309 28.28-3.239 35.59 9.076l2.098-1.244c-6.225 21.092 2.671 44.494 22.644 55.706 12.417 6.969 26.627 7.828 39.154 3.568l-6.037-21.479zm-45.1-44.13z",
  fill: "#ff9811"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M319.191 200.915l-12.062 43.047-36.194-6.684-23.297-48.023-62.938 22.334-4.964-13.986-16.466-2.029 12.407 34.966 43.313-11.077 12.309 34.686-29.941 44.187 50.81 43.337-9.631 11.292 6.476 15.277 24.078-28.229-31.249-31.97 23.885-28.002 53.238 3.837 12.127-65.673 14.594 2.695 9.993-13.247-36.488-6.738zm-63.204 56.241v.001-.001z",
  fill: "#ffeacf"
});

const SvgSicily = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSicily, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sicily.4cef81e9.svg";
export { ForwardRef as ReactComponent };